import React, { useState } from 'react';

 // Import CSS for styling

import { useEmailApi } from '../../auth/helper/api/emailApi';

const EmailSendManualTriggerPage = () => {
  
  

  const emailApi = useEmailApi();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleSubmit = async (e) => {
    

    e.preventDefault();
    try {
      const response = await emailApi.post(
        `${process.env.REACT_APP_SET_RESEND_EMAIL_ENDPOINT}`
      );
      
      if (response.status === 200) {
        setSuccess('Resend Email is triggered successfully!');
        setError(null); // Clear any errors
      } else {
        setError(`Error: ${response.data.message}`);
      }
    } catch (err) {
      setError(err.message || 'An error occurred while submitting the request.');
      setSuccess(null); // Clear success message
    }
  };

  return (
    <div className="page-container">
      <h2>Trigger Email Manually</h2>

      <form onSubmit={handleSubmit} className="standard-form">
        

        <button type="submit">Enter</button>

        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}
      </form>
    </div>
  );
};

export default EmailSendManualTriggerPage;
